import { DownOutlined } from '@ant-design/icons';
import { useRef, useState } from 'react';
import styled from 'styled-components';

import Avatar from '@/components/Avatar/Avatar';
import { Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import WorkspaceDropdown from '@/features/Commons/Sidebar/WorkspaceDropdown';
import useColor from '@/hooks/domain/useColor';
import useFixed from '@/hooks/pure/useFixed';
import useUserStore from '@/stores/UserStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { ellipsisText } from '@/styles/style';
import zIndex from '@/styles/zIndex';
import { charToNumber } from '@/utils/util';

function PluginHeader() {
  const color = useColor();
  const [dropdownClicked, setDropdownClicked] = useState(false);
  const user = useUserStore((state) => state.user);
  const workspaceRef = useRef<HTMLDivElement>(null);
  const { currWorkspace } = useWorkspaceStore((state) => ({
    currWorkspace: state.currWorkspace,
  }));
  const workspaceDropdownPos = useFixed(workspaceRef, {
    reflect: {
      x: true,
    },
  });

  return (
    <Flex a="center" j="space-between">
      <VFlex g={6}>
        <Typo type="label1" color={color.gray700} weight="b">
          Syncly
        </Typo>

        <Typo type="label3" color={color.gray600} weight="m">
          Real time customer sentiment trend and visibility
        </Typo>
      </VFlex>

      <Flex>
        <SelectedWorkspaceWrapper
          onClick={() => {
            user && setDropdownClicked(!dropdownClicked);
          }}
          ref={workspaceRef}
        >
          <Avatar
            character={currWorkspace?.name[0].toUpperCase() || '?'}
            color={color.profile[charToNumber(currWorkspace?.name || '?')]}
            size={28}
            fontSize="16px"
            style={{
              borderRadius: 3,
            }}
          />
          <Typo
            style={{ userSelect: 'none' }}
            weight="m"
            type="body3"
            color={color.gray700}
            className="workspace-name"
          >
            {currWorkspace?.name}
          </Typo>
          {user && (
            <DownOutlined style={{ fontSize: '14px', color: color.gray700 }} />
          )}
        </SelectedWorkspaceWrapper>
        <WorkspaceDropdown
          status={dropdownClicked}
          style={{
            position: 'fixed',
            ...workspaceDropdownPos,
            zIndex: zIndex.dropdown,
          }}
          close={() => setDropdownClicked(false)}
          modalWidth="240px"
        >
          <WorkspaceDropdown.UserInfo />
          <WorkspaceDropdown.WorkspaceList />
          <WorkspaceDropdown.LogOut />
        </WorkspaceDropdown>
      </Flex>
    </Flex>
  );
}

export default PluginHeader;

const SelectedWorkspaceWrapper = styled(Flex)`
  cursor: pointer;
  height: 28px;
  font-size: 12px;
  align-items: center;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  transition: all 0.2s;
  gap: 9px;
  &:hover {
    filter: brightness(1.1);
  }
  .workspace-name {
    max-width: 145px;
    text-align: left;
    ${ellipsisText};
  }
`;
